import React from 'react';
import '../styles/login.css';
import NavBar from '../components/navbar';
import { Paper, TextField, Button, Typography, Tooltip, InputAdornment, IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import * as auth from '../data/firebaseAuth';
import history from '../components/history';

const rootClass = "login root";
const inputClass = "login input";
const submitClass = "login submit";
const titleClass = "login title";
const forgotPasswordClass = "login forgotPassword";
const enabledPostfix = " enabled";
const disabledPostfix = " disabled";
const registerClass = "login register";
const errorClass = "login error";

class Login extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            email: "",
            password: "",
            passwordVisible: false,
            forgotPassword: false,
            processingLogin: false,
            emailNotVerified: false,
        }
        this.forgotPassword = this.forgotPassword.bind(this);
        this.loginBtn = this.loginBtn.bind(this);
    }

    async componentDidMount() {
        if (await auth.getCurrentUser()) {
            history.push('/');
        }
    }

    textHandler = name => event => {
        this.setState({ [name]: event.target.value });
    };

    render() {
        if (this.state.emailNotVerified) {
            setTimeout(() => history.push('/'), 10000);
            return (
                <>
                    <NavBar />
                    <div className={errorClass}>
                        <Typography variant="h4">
                            The account you are trying to log in with does not have its E-Mail verified!<br />
                            Please check if you've gotten an E-Mail from our service.<br />
                            If you are experiencing further problems, please contact the webmaster.
                        </Typography>
                        <Typography variant="h6">You will be redirected in 10 seconds.</Typography>
                    </div>
                </>
            )
        }
        return (
            <>
                <NavBar />
                <Paper className={rootClass}>
                    <Typography variant="h3" className={titleClass}>Anmelden</Typography>
                    <TextField label="Email" value={this.state.email} onChange={this.textHandler('email')} type="email" className={inputClass} variant="outlined" required fullWidth></TextField>
                    <TextField label="Passwort" value={this.state.password} onChange={this.textHandler('password')} onKeyPress={(ev) => { if (ev.key === 'Enter') { ev.preventDefault(); this.loginBtn(); } }} type={this.state.passwordVisible ? "text" : "password"} className={inputClass} variant="outlined" required fullWidth InputProps={{
                        endAdornment: (<InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => this.setState({ passwordVisible: !this.state.passwordVisible })}
                                edge="end"
                            >
                                {this.state.passwordVisible ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>)
                    }}></TextField>
                    <Button color="primary" className={submitClass} variant="contained" onClick={this.loginBtn} disabled={this.state.processingLogin} fullWidth>Anmelden</Button>
                </Paper>
                <div className={rootClass}>
                    {!(this.state.email.length >= 5 && this.state.email.includes("@")) &&
                        (<Tooltip title="Bitte erst Email eingeben" placement="bottom">
                            <Typography variant="h6" className={forgotPasswordClass + disabledPostfix}>Passwort vergessen?</Typography>
                        </Tooltip>)
                    }
                    {(this.state.email.length >= 5 && this.state.email.includes("@")) &&
                        <Typography variant="h6" className={forgotPasswordClass + enabledPostfix} onClick={this.forgotPassword}>Passwort vergessen?</Typography>
                    }
                    <Typography variant="h6" className={registerClass} onClick={() => history.push('/register')} >Noch nicht registriert?</Typography>
                </div>
            </>
        );
    }

    async forgotPassword() {
        if (this.state.email.length >= 5 && this.state.email.includes("@")) {
            if (!this.state.forgotPassword) {
                await this.setState({
                    forgotPassword: true,
                });
                auth.forgotPasswort(this.state.email);
            }
        }
    }

    async loginBtn() {
        await this.setState({
            processingLogin: true,
        });
        await auth.login(this.state.email, this.state.password);
        const u = await auth.getCurrentUser();
        if (u) {
            if (u.emailVerified) {
                history.push('/');
            } else {
                await auth.logout();
                this.setState({ emailNotVerified: true, });
            }
        }
    }

}

export default Login;